(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const toggle = qs('[data-menu-toggle]');
  const mobileNav = qs('[data-mobile-nav]');
  toggle?.addEventListener('click', () => {
    mobileNav?.classList.toggle('is-open');
    toggle.setAttribute('aria-expanded', mobileNav.classList.contains('is-open'));
  });

  const hero = qs('[data-hero]');
  if (hero) {
    const slides = qsa('[data-hero-slide]', hero);
    const dots = qsa('[data-hero-dot]', hero);
    let i = 0;
    const show = (n) => {
      i = (n + slides.length) % slides.length;
      slides.forEach((el, idx) => el.classList.toggle('is-active', idx === i));
      dots.forEach((el, idx) => el.classList.toggle('is-active', idx === i));
    };
    dots.forEach((dot, idx) => dot.addEventListener('click', () => show(idx)));
    qs('[data-hero-prev]', hero)?.addEventListener('click', () => show(i - 1));
    qs('[data-hero-next]', hero)?.addEventListener('click', () => show(i + 1));
    if (slides.length) setInterval(() => show(i + 1), 7000);
  }

  const drawer = qs('[data-cart-drawer]');
  const openDrawer = () => drawer?.classList.add('is-open');
  const closeDrawer = () => drawer?.classList.remove('is-open');
  qsa('[data-open-cart]').forEach((el) => el.addEventListener('click', (e) => {
    if (drawer && document.body.dataset.cartDrawer === 'true') {
      e.preventDefault();
      openDrawer();
    }
  }));
  drawer?.querySelector('[data-close-cart]')?.addEventListener('click', closeDrawer);
  drawer?.querySelector('[data-cart-overlay]')?.addEventListener('click', closeDrawer);

  const formatCart = (cart) => {
    const itemsEl = qs('[data-cart-items]');
    const countEls = qsa('[data-cart-count]');
    const subtotalEl = qs('[data-cart-subtotal]');
    countEls.forEach((el) => { el.textContent = cart.item_count; });
    if (subtotalEl) subtotalEl.textContent = cart.items.length ? formatMoney(cart.total_price) : '';
    if (!itemsEl) return;
    if (!cart.items.length) {
      itemsEl.innerHTML = '<p>Your cart is empty.</p>';
      return;
    }
    itemsEl.innerHTML = cart.items.map((item) => `
      <div class="cart-line">
        <img src="${item.image || ''}" alt="${escapeHtml(item.title)}">
        <div>
          <div>${escapeHtml(item.title)}</div>
          <div>${item.quantity} × ${formatMoney(item.final_line_price / item.quantity)}</div>
        </div>
        <button type="button" data-remove-item="${item.key}">Remove</button>
      </div>
    `).join('');
  };

  const formatMoney = (cents) => {
    try {
      return (window.Shopify?.formatMoney)
        ? Shopify.formatMoney(cents)
        : `$${(cents / 100).toFixed(2)}`;
    } catch {
      return `$${(cents / 100).toFixed(2)}`;
    }
  };
  const escapeHtml = (s) => String(s).replace(/[&<>"']/g, (c) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[c]));

  const refreshCart = () => fetch('/cart.js').then((r) => r.json()).then(formatCart);

  document.addEventListener('click', async (e) => {
    const remove = e.target.closest('[data-remove-item]');
    if (remove) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: remove.dataset.removeItem, quantity: 0 })
      });
      refreshCart();
    }
  });

  qsa('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      if (document.body.dataset.cartDrawer !== 'true') return;
      e.preventDefault();
      const data = new FormData(form);
      await fetch('/cart/add.js', { method: 'POST', body: data });
      await refreshCart();
      openDrawer();
    });
  });

  const thumbs = qsa('[data-product-thumb]');
  const main = qs('[data-product-main]');
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      if (main) main.src = thumb.dataset.productThumb;
    });
  });

  const searchInput = qs('[data-predictive-search]');
  const results = qs('[data-predictive-results]');
  let t;
  searchInput?.addEventListener('input', () => {
    clearTimeout(t);
    const q = searchInput.value.trim();
    if (q.length < 2) { results?.classList.remove('is-open'); return; }
    t = setTimeout(async () => {
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
      const json = await res.json();
      const products = json.resources?.results?.products || [];
      if (!results) return;
      results.innerHTML = products.map((p) => `
        <a href="${p.url}">
          <img src="${p.image || ''}" alt="">
          <span>${escapeHtml(p.title)}</span>
        </a>
      `).join('') || '<div style="padding:8px">No results</div>';
      results.classList.add('is-open');
    }, 200);
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-header-search]')) results?.classList.remove('is-open');
  });

  refreshCart().catch(() => {});
})();
